import React, { useState } from "react";
import { Box } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { dt } from "../../../../shared/themes/redesignTokens";
import useTranslation from "../../../../shared/hooks/useTranslation";
import QuickCreateInline from "./QuickCreateInline";

interface QuickCreateCardProps {
  onCreated: () => void;
}

const QuickCreateCard = ({ onCreated }: QuickCreateCardProps) => {
  const { translate } = useTranslation("operations");
  const [expanded, setExpanded] = useState(false);

  if (expanded) {
    return (
      <QuickCreateInline
        onCreated={() => {
          setExpanded(false);
          onCreated();
        }}
        onCancel={() => setExpanded(false)}
      />
    );
  }

  return (
    <Box
      onClick={() => setExpanded(true)}
      sx={{
        border: `2px dashed ${dt.cardBorder}`,
        borderRadius: dt.radiusSm,
        padding: "16px",
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.2s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "4px",
        "&:hover": {
          borderColor: dt.blue,
          color: dt.blue,
          backgroundColor: dt.blueSoft,
        },
      }}
    >
      <AddRounded
        sx={{
          fontSize: 18,
          color: "inherit",
          opacity: 0.7,
        }}
      />
      <Box
        sx={{
          fontFamily: dt.font,
          fontSize: "12px",
          fontWeight: 500,
          color: dt.textMuted,
          "&:hover": { color: dt.blue },
        }}
      >
        {translate("quickCreate.addWorkOrder")}
      </Box>
    </Box>
  );
};

export default QuickCreateCard;
